import { render } from "./SpecificRequirementsDisplay.vue?vue&type=template&id=06bde2fb&scoped=true"
import script from "./SpecificRequirementsDisplay.vue?vue&type=script&lang=js"
export * from "./SpecificRequirementsDisplay.vue?vue&type=script&lang=js"

import "./SpecificRequirementsDisplay.vue?vue&type=style&index=0&id=06bde2fb&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bde2fb"]])

export default __exports__